import { useCallback } from 'react';
import { useAuth } from '@clerk/react';

export function useApiClient(): {
  fetchApi: (endpoint: string, options?: RequestInit) => Promise<Response>;
} {
  const { getToken } = useAuth();

  const fetchApi = useCallback(
    async (endpoint: string, options?: RequestInit): Promise<Response> => {
      let token: string | null;
      try {
        token = await getToken();
      } catch {
        window.location.href = '/sign-in';
        return new Response(null, { status: 401 });
      }

      if (!token) {
        window.location.href = '/sign-in';
        return new Response(null, { status: 401 });
      }

      const baseUrl = import.meta.env.VITE_API_BASE || '/api';
      return fetch(`${baseUrl}${endpoint}`, {
        ...options,
        credentials: 'include',
        headers: {
          ...((options?.headers as Record<string, string>) ?? {}),
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [getToken],
  );

  return { fetchApi };
}
